import {AgeConfirmStore} from "alpine";
import type { Alpine } from "alpinejs";

export function registerAgeConfirmStore(alpine: Alpine) {
    const store: AgeConfirmStore = {
        hasSeen: alpine.$persist(false).as('ageChecked') as unknown as boolean,
        dialog: null as HTMLDialogElement | null,

        confirmAge() {
            this.hasSeen = true;
            if (this.dialog?.open) {
                this.dialog.close();
            }
            window.location.hash = '';
        },

        declineAge() {
            if (this.dialog?.open) {
                this.dialog.close();
            }
            window.location.hash = 'pouze-pro-dospele';
        },

        open() {
            if (!this.hasSeen && this.dialog && !this.dialog.open) {
                this.dialog.showModal();
            }
        }
    };

    alpine.store('ageConfirm', store);
}
